var map = {
	"./ATM.vue": [
		83136,
		[
			3136
		]
	],
	"./admin-menu.vue": [
		12840,
		[
			2840
		]
	],
	"./agent.vue": [
		34483,
		[
			4483
		]
	],
	"./arrow-down-2.vue": [
		12844,
		[
			2844
		]
	],
	"./arrow-down-from-line.vue": [
		38685,
		[
			8685
		]
	],
	"./arrow-down-left.vue": [
		99845,
		[
			9845
		]
	],
	"./arrow-down-up.vue": [
		13304,
		[
			3304
		]
	],
	"./arrow-down.vue": [
		20301,
		[
			301
		]
	],
	"./arrow-left-right.vue": [
		58721,
		[
			8721
		]
	],
	"./arrow-left.vue": [
		75344,
		[
			5344
		]
	],
	"./arrow-mini.vue": [
		49026,
		[
			9026
		]
	],
	"./arrow-right-left.vue": [
		7349,
		[
			7349
		]
	],
	"./arrow-transfer.vue": [
		65329,
		[
			5329
		]
	],
	"./arrow-up-2.vue": [
		28484,
		[
			8484
		]
	],
	"./arrow-up-down.vue": [
		24897,
		[
			4897
		]
	],
	"./arrow-up-from-line.vue": [
		60853,
		[
			853
		]
	],
	"./arrow-up-right.vue": [
		78245,
		[
			8245
		]
	],
	"./arrow-up.vue": [
		89464,
		[
			9464
		]
	],
	"./arrow.vue": [
		91288,
		[
			1288
		]
	],
	"./assets.vue": [
		68482,
		[
			8482
		]
	],
	"./banknote.vue": [
		79275,
		[
			9275
		]
	],
	"./bell-dot.vue": [
		71087,
		[
			1087
		]
	],
	"./bell.vue": [
		43207,
		[
			3207
		]
	],
	"./blocks.vue": [
		88314,
		[
			8314
		]
	],
	"./bot-message.vue": [
		88418,
		[
			6037
		]
	],
	"./burger.vue": [
		98689,
		[
			8689
		]
	],
	"./calendar.vue": [
		88270,
		[
			8270
		]
	],
	"./cancel-bg-red.vue": [
		24018,
		[
			4018
		]
	],
	"./card.vue": [
		17819,
		[
			7819
		]
	],
	"./check-green-bg.vue": [
		38418,
		[
			8418
		]
	],
	"./check-green.vue": [
		73843,
		[
			3843
		]
	],
	"./check-mark.vue": [
		77194,
		[
			7194
		]
	],
	"./chevron-down.vue": [
		19522,
		[
			9522
		]
	],
	"./chevron-left.vue": [
		91818,
		[
			1818
		]
	],
	"./chevron-right.vue": [
		88363,
		[
			8363
		]
	],
	"./chevron-up-down.vue": [
		34321,
		[
			4321
		]
	],
	"./chevron-up.vue": [
		58843,
		[
			1224
		]
	],
	"./circle-check.vue": [
		29553,
		[
			9553
		]
	],
	"./circle-dollar-sign.vue": [
		74766,
		[
			4766
		]
	],
	"./circle-progress.vue": [
		14575,
		[
			4575
		]
	],
	"./circle-x.vue": [
		66127,
		[
			6127
		]
	],
	"./clear-search.vue": [
		64253,
		[
			4253
		]
	],
	"./clip-files.vue": [
		57649,
		[
			7649
		]
	],
	"./clipboard-list.vue": [
		56333,
		[
			6333
		]
	],
	"./clock.vue": [
		4859,
		[
			4859
		]
	],
	"./close.vue": [
		14310,
		[
			4310
		]
	],
	"./code-xml.vue": [
		18309,
		[
			8309
		]
	],
	"./coins-pair.vue": [
		45625,
		[
			5625
		]
	],
	"./coins.vue": [
		69109,
		[
			9109
		]
	],
	"./copy.vue": [
		9528,
		[
			9528
		]
	],
	"./credit-card.vue": [
		19835,
		[
			9835
		]
	],
	"./crypto-ADA.vue": [
		17685,
		[
			7685
		]
	],
	"./crypto-ALGO.vue": [
		45071,
		[
			5071
		]
	],
	"./crypto-APT.vue": [
		83780,
		[
			3780
		]
	],
	"./crypto-ARB.vue": [
		55705,
		[
			5705
		]
	],
	"./crypto-AVAX.vue": [
		56760,
		[
			6760
		]
	],
	"./crypto-BASE.vue": [
		99014,
		[
			9014
		]
	],
	"./crypto-BCH.vue": [
		26493,
		[
			6493
		]
	],
	"./crypto-BSC.vue": [
		98515,
		[
			8515
		]
	],
	"./crypto-BSV.vue": [
		20048,
		[
			7667
		]
	],
	"./crypto-BTC.vue": [
		92710,
		[
			2710
		]
	],
	"./crypto-DOGE.vue": [
		80878,
		[
			878
		]
	],
	"./crypto-DOT.vue": [
		97048,
		[
			7048
		]
	],
	"./crypto-ETC.vue": [
		25373,
		[
			5373
		]
	],
	"./crypto-ETH.vue": [
		1838,
		[
			1838
		]
	],
	"./crypto-LTC.vue": [
		28327,
		[
			8327
		]
	],
	"./crypto-MATIC.vue": [
		71672,
		[
			1672
		]
	],
	"./crypto-NEAR.vue": [
		41597,
		[
			1597
		]
	],
	"./crypto-OP.vue": [
		52512,
		[
			2512
		]
	],
	"./crypto-SOL.vue": [
		44171,
		[
			4171
		]
	],
	"./crypto-TON.vue": [
		64750,
		[
			4750
		]
	],
	"./crypto-TRX.vue": [
		66322,
		[
			6322
		]
	],
	"./crypto-TetherOMNI.vue": [
		6355,
		[
			6355
		]
	],
	"./crypto-XLM.vue": [
		74677,
		[
			4677
		]
	],
	"./crypto-XRP.vue": [
		2752,
		[
			2752
		]
	],
	"./crypto-XTZ.vue": [
		44015,
		[
			4015
		]
	],
	"./crypto-ZEC.vue": [
		81661,
		[
			1661
		]
	],
	"./cryptocurr-new.vue": [
		41085,
		[
			1085
		]
	],
	"./cryptocurr.vue": [
		58898,
		[
			8898
		]
	],
	"./data.vue": [
		69838,
		[
			9838
		]
	],
	"./default-curr.vue": [
		42288,
		[
			2288
		]
	],
	"./deposit.vue": [
		72827,
		[
			2827
		]
	],
	"./dialog.vue": [
		65579,
		[
			5579
		]
	],
	"./dispute-in-progress.vue": [
		41734,
		[
			1734
		]
	],
	"./dollar-sign.vue": [
		40712,
		[
			712
		]
	],
	"./double-check.vue": [
		59694,
		[
			9694
		]
	],
	"./download-file.vue": [
		68058,
		[
			8058
		]
	],
	"./echeck-new.vue": [
		81136,
		[
			1136
		]
	],
	"./echeck.vue": [
		15015,
		[
			5015
		]
	],
	"./edit.vue": [
		88933,
		[
			8933
		]
	],
	"./edit_k.vue": [
		96373,
		[
			6373
		]
	],
	"./edit_va.vue": [
		78279,
		[
			8279
		]
	],
	"./ellipsis.vue": [
		2514,
		[
			2514
		]
	],
	"./empty-uploader.vue": [
		75828,
		[
			3447
		]
	],
	"./error.vue": [
		84624,
		[
			4624
		]
	],
	"./eshop.vue": [
		24693,
		[
			4693
		]
	],
	"./exchange.vue": [
		73887,
		[
			3887
		]
	],
	"./export.vue": [
		12027,
		[
			2027
		]
	],
	"./external-link.vue": [
		15666,
		[
			5666
		]
	],
	"./external.vue": [
		62242,
		[
			2242
		]
	],
	"./eye-dollar.vue": [
		97020,
		[
			7020
		]
	],
	"./eye-off.vue": [
		52398,
		[
			2398
		]
	],
	"./eye.vue": [
		77146,
		[
			7146
		]
	],
	"./fallback-circle.vue": [
		46659,
		[]
	],
	"./feedback.vue": [
		59311,
		[
			9311
		]
	],
	"./file-question.vue": [
		41891,
		[
			1891
		]
	],
	"./file-text.vue": [
		81096,
		[
			1096
		]
	],
	"./file-user.vue": [
		52647,
		[
			2647
		]
	],
	"./filter-select-clear.vue": [
		68125,
		[
			8125
		]
	],
	"./filter.vue": [
		97180,
		[
			7180
		]
	],
	"./full-table.vue": [
		58909,
		[
			8909
		]
	],
	"./gears.vue": [
		89436,
		[
			9436
		]
	],
	"./globe.vue": [
		96841,
		[
			6841
		]
	],
	"./hand-coins.vue": [
		5771,
		[
			5771
		]
	],
	"./hashtag.vue": [
		75381,
		[
			5381
		]
	],
	"./headset.vue": [
		33200,
		[
			3200
		]
	],
	"./history.vue": [
		62675,
		[
			2675
		]
	],
	"./home_vs.vue": [
		91662,
		[
			1662
		]
	],
	"./horizontal_arr.vue": [
		64545,
		[
			4545
		]
	],
	"./hourglass.vue": [
		6951,
		[
			6951
		]
	],
	"./iconname.vue": [
		65764,
		[
			5764
		]
	],
	"./info.vue": [
		44882,
		[
			4882
		]
	],
	"./inform-auth.vue": [
		61269,
		[
			1269
		]
	],
	"./inform-card.vue": [
		72930,
		[
			2930
		]
	],
	"./inform-income.vue": [
		97813,
		[
			7813
		]
	],
	"./inform-mail.vue": [
		49366,
		[
			9366
		]
	],
	"./inform-outcome.vue": [
		98203,
		[
			8203
		]
	],
	"./inform-payrequest.vue": [
		28657,
		[
			8657
		]
	],
	"./inform-security.vue": [
		47464,
		[
			7464
		]
	],
	"./inform-shop.vue": [
		78695,
		[
			8695
		]
	],
	"./key-round.vue": [
		93028,
		[
			3028
		]
	],
	"./key.vue": [
		58549,
		[
			8549
		]
	],
	"./languages.vue": [
		79168,
		[
			9168
		]
	],
	"./layout-dashboard.vue": [
		78962,
		[
			8962
		]
	],
	"./layout-template.vue": [
		1754,
		[
			1754
		]
	],
	"./like.vue": [
		50905,
		[
			905
		]
	],
	"./link.vue": [
		52161,
		[
			2161
		]
	],
	"./linkedin.vue": [
		35170,
		[
			5170
		]
	],
	"./list-checks.vue": [
		35859,
		[
			5859
		]
	],
	"./list-collapse.vue": [
		93874,
		[
			1493
		]
	],
	"./list-restart.vue": [
		24902,
		[
			4902
		]
	],
	"./lng.vue": [
		96059,
		[
			6059
		]
	],
	"./lock-open.vue": [
		66915,
		[
			6915
		]
	],
	"./lock.vue": [
		98004,
		[
			8004
		]
	],
	"./log-out.vue": [
		46713,
		[
			9094
		]
	],
	"./logout.vue": [
		32285,
		[
			2285
		]
	],
	"./mail-check.vue": [
		44391,
		[
			4391
		]
	],
	"./mail.vue": [
		90331,
		[
			331
		]
	],
	"./masspay-new.vue": [
		34593,
		[
			4593
		]
	],
	"./masspay.vue": [
		71206,
		[
			1206
		]
	],
	"./menu.vue": [
		66709,
		[
			6709
		]
	],
	"./message-send.vue": [
		38704,
		[
			8704
		]
	],
	"./messages-square.vue": [
		93086,
		[
			3086
		]
	],
	"./minus.vue": [
		81034,
		[
			1034
		]
	],
	"./money-bag.vue": [
		58896,
		[
			8896
		]
	],
	"./money.vue": [
		39637,
		[
			9637
		]
	],
	"./money_burn.vue": [
		88246,
		[
			8246
		]
	],
	"./name.vue": [
		41921,
		[
			4302
		]
	],
	"./notify.vue": [
		17016,
		[
			7016
		]
	],
	"./order-support.vue": [
		80920,
		[
			920
		]
	],
	"./orders.vue": [
		55247,
		[
			5247
		]
	],
	"./p2p-new.vue": [
		94495,
		[
			4495
		]
	],
	"./p2p.vue": [
		9558,
		[
			9558
		]
	],
	"./password.vue": [
		57246,
		[
			7246
		]
	],
	"./pay-new.vue": [
		82184,
		[
			2184
		]
	],
	"./pay.vue": [
		89178,
		[
			9178
		]
	],
	"./pencil.vue": [
		1624,
		[
			1624
		]
	],
	"./phone.vue": [
		69837,
		[
			9837
		]
	],
	"./plus.vue": [
		86004,
		[
			6004
		]
	],
	"./question.vue": [
		48807,
		[
			8807
		]
	],
	"./rates.vue": [
		88139,
		[
			8139
		]
	],
	"./receipt-text.vue": [
		37749,
		[
			7749
		]
	],
	"./refresh-ccw.vue": [
		42085,
		[
			2085
		]
	],
	"./refresh.vue": [
		60092,
		[
			92
		]
	],
	"./repeat.vue": [
		81066,
		[
			1066
		]
	],
	"./search-grey.vue": [
		29263,
		[
			9263
		]
	],
	"./search-select.vue": [
		18843,
		[
			8843
		]
	],
	"./search.vue": [
		52939,
		[
			2939
		]
	],
	"./settings.vue": [
		5122,
		[
			5122
		]
	],
	"./shield-check.vue": [
		43266,
		[
			3266
		]
	],
	"./shield.vue": [
		68618,
		[
			8618
		]
	],
	"./shop-placeholder.vue": [
		13202,
		[
			3202
		]
	],
	"./star-outline.vue": [
		36626,
		[
			6626
		]
	],
	"./star.vue": [
		89269,
		[
			9269
		]
	],
	"./store.vue": [
		53874,
		[
			3874
		]
	],
	"./support.vue": [
		79953,
		[
			9953
		]
	],
	"./table.vue": [
		17299,
		[
			7299
		]
	],
	"./template-new.vue": [
		65325,
		[
			5325
		]
	],
	"./template.vue": [
		73358,
		[
			3358
		]
	],
	"./test-coin.vue": [
		73328,
		[
			3328
		]
	],
	"./test.vue": [
		85346,
		[
			5346
		]
	],
	"./text.vue": [
		41967,
		[
			1967
		]
	],
	"./time-is-up.vue": [
		79092,
		[
			9092
		]
	],
	"./timeline-time-is-up-mobile.vue": [
		13518,
		[
			3518
		]
	],
	"./timeline-time-is-up.vue": [
		59575,
		[
			9575
		]
	],
	"./tools.vue": [
		2284,
		[
			2284
		]
	],
	"./trash-p2p.vue": [
		44523,
		[
			4523
		]
	],
	"./trash.vue": [
		23766,
		[
			3766
		]
	],
	"./undo.vue": [
		15675,
		[
			5675
		]
	],
	"./update.vue": [
		6611,
		[
			6611
		]
	],
	"./uploader.vue": [
		68506,
		[
			8506
		]
	],
	"./user-round-cog.vue": [
		93855,
		[
			3855
		]
	],
	"./user-search.vue": [
		23580,
		[
			3580
		]
	],
	"./user.vue": [
		22669,
		[
			2669
		]
	],
	"./users.vue": [
		75920,
		[
			5920
		]
	],
	"./va-facebook.vue": [
		53337,
		[
			3337
		]
	],
	"./va-host.vue": [
		11486,
		[
			1486
		]
	],
	"./va-mail.vue": [
		61436,
		[
			1436
		]
	],
	"./va-telegram.vue": [
		9593,
		[
			9593
		]
	],
	"./va-twitter.vue": [
		31473,
		[
			1473
		]
	],
	"./va-white-book.vue": [
		87493,
		[
			7493
		]
	],
	"./va.vue": [
		35744,
		[
			5744
		]
	],
	"./verify.vue": [
		42508,
		[
			2508
		]
	],
	"./wallet.vue": [
		81859,
		[
			1859
		]
	],
	"./wand.vue": [
		12445,
		[
			2445
		]
	],
	"./warning-info.vue": [
		9516,
		[
			9516
		]
	],
	"./warning-keyt.vue": [
		30094,
		[
			94
		]
	],
	"./warning-money.vue": [
		25073,
		[
			5073
		]
	],
	"./whatsapp.vue": [
		66518,
		[
			4137
		]
	],
	"./withdraw.vue": [
		98656,
		[
			8656
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(function(id) { return __webpack_require__.e(id); })).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40259;
module.exports = webpackAsyncContext;